import { curSym, getOptionLabel } from "../auth/Pip";
import { lengthOptions } from "../auth/data";
import { ServicePresetSchema } from "../auth/Schema";
import { Formik } from "formik";
import ErrorMessage from "../components/ErrorMessage";
import Header from "../components/Header";
import Loader from "../components/Loader";
import Sidebar from "../components/Sidebar";
import SubHeader from "../components/SubHeader";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactPagination from "../layout/ReactPagination";
import DeleteModal from "../components/modals/DeleteModal";
import PaginationDropdown from "../layout/PaginationDropdown";
import GuidedTour from "../components/GuidedTour";
import {
  addPreset,
  deletePreset,
  fetchPresetById,
  fetchPresets,
  updatePreset,
} from "../redux/actions/servicePresetsActions";
import { pageRoutes } from "../routes/PageRoutes";
import { useNavigate } from "react-router-dom";
import { resetTour } from "../redux/reducers/tourReducer";

const ServicePresetModal = ({
  isEditMode,
  modalRef,
  onSubmit,
  selectedService,
}) => {
  const initialValues = {
    serviceTitle: selectedService?.serviceTitle ?? "",
    serviceCost: selectedService?.serviceCost ?? "",
    boatLength: selectedService?.boatLength ?? "",
    materialCost: selectedService?.materialCost ?? "",
  };

  return (
    <div
      ref={modalRef}
      className="modal fade"
      id="ct_service_modal"
      tabIndex={-1}
      aria-labelledby="ct_service_modal_label"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content ct_border_radius_20">
          <div className="modal-body">
            <div className="ct_delete_post_modal p-4">
              <figure>
                <figcaption>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h4
                        id="ct_service_modal_label"
                        className="ct_fs_24 ct_fw_600 ct_blue_text mb-2"
                      >
                        {isEditMode ? "Edit Service" : "Add Service"}
                      </h4>
                      <p className="mb-0 ct_text_para ct_fs_16">
                        {isEditMode
                          ? "Update service details to keep your tasks accurate and consistent."
                          : "Create a predefined service to speed up task creation and ensure consistent pricing."}
                      </p>
                    </div>
                    <div data-bs-dismiss="modal" className="ct_pointer">
                      <i className="fa-solid fa-xmark"></i>
                    </div>
                  </div>
                </figcaption>

                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  validationSchema={ServicePresetSchema}
                  onSubmit={onSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <>
                      <div className="service-highlight mt-5">
                        <form className="">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="form-group mb-3">
                                <label className="form-label">
                                  Service Title
                                  <span className="ct_required_star">*</span>
                                </label>
                                <input
                                  id="serviceTitle"
                                  name="serviceTitle"
                                  type="text"
                                  className="form-control ct_input ct_transparent_input"
                                  placeholder="Enter service title"
                                  value={values?.serviceTitle}
                                  required
                                  disabled={isEditMode}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="serviceTitle"
                                />
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form-group mb-3">
                                <label className="form-label">
                                  Service Cost ({curSym})
                                  <span className="ct_required_star">*</span>
                                </label>
                                <input
                                  id="serviceCost"
                                  type="number"
                                  min="0"
                                  step="0.01"
                                  className="form-control ct_input ct_transparent_input"
                                  placeholder="Enter service cost"
                                  value={values?.serviceCost}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  onWheel={(e) => e.target.blur()}

                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="serviceCost"
                                />
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form-group mb-3">
                                <label className="form-label">
                                  Boat Length
                                </label>
                                <select
                                  id="boatLength"
                                  name="boatLength"
                                  className="form-control ct_input ct_transparent_input"
                                  value={values?.boatLength}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <option value="">Select boat length (FT)</option>
                                  {lengthOptions.map((item, index) => (
                                    <option key={index} value={item.value}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="boatLength"
                                />
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form-group mb-3">
                                <label className="form-label">
                                  Material Cost ({curSym})
                                </label>
                                <input
                                  id="materialCost"
                                  type="number"
                                  min="0"
                                  step="0.01"
                                  className="form-control ct_input ct_transparent_input"
                                  placeholder="Enter service cost"
                                  value={values?.materialCost}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  onWheel={(e) => e.target.blur()}

                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="materialCost"
                                />
                              </div>
                            </div>
                          </div>
                        </form>

                        <div className="d-flex justify-content-end border-0 gap-2 ct_modal_footer ct_mt_30">
                          <a
                            data-bs-dismiss="modal"
                            className="ct_border_radius_5 ct_h_40 ct_orange_transparent_btn px-5 text-center ct_pointer"
                          >
                            Cancel
                          </a>
                          <button
                            type="button"
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                            className="ct_border_radius_5 ct_h_40 ct_orange_btn px-5 text-center border-0 service_preset_submit_btn"
                          >
                            {isEditMode ? "Save Changes" : "Add Service"}
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </Formik>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ManageServicePresets = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const modalRef = useRef(null);
  const autoOpenModalAttemptedRef = useRef(false);
  const TOUR_PERSIST_KEY = "fm_tour_service_presets_stepindex_v1";
  const [filterData, setFilterData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);
  const [id, setId] = useState("");
  const [selectedService, setSelectedService] = useState(null);
  const [runTour, setRunTour] = useState(false);
  const [showAllSet, setShowAllSet] = useState(false);
  const tourSteps = React.useMemo(
    () => [
      {
        target: ".add_service_btn",
        title: "Add Service",
        content: "Click Next to add your first service preset.",
        placement: "left",
        nextLabel: "Next",
        skipLabel: "Skip",
        showSkipButton: true,
        className: "adDocBtn",
        onNext: () => {
          const button = document.querySelector(".add_service_btn");
          button?.click?.();
        },
        nextDelay: 300,
      },
      {
        target: ".service_preset_submit_btn",
        spotlightTarget: "#ct_service_modal .service-highlight",
        title: "Service details",
        content: "Fill the details here, then click Next.",
        placement: "bottom",
        nextLabel: "Next",
        skipLabel: "Skip",
        showSkipButton: true,
      },
    ],
    [],
  );

  const { isLoading, serviceList } = useSelector(
    (state) => state?.servicePresetsReducer,
  );
  const tooltipSeen = useSelector((state) => state?.authReducer?.tooltipSeen);
  const { active: isTourActive, step: tourStep } = useSelector(
    (state) => state?.tourReducer,
  );
  const [isToggle, setIsToggle] = useState(false);

  const normalizedQuery = filterData.trim().toLowerCase();
  const filterList = serviceList?.filter((item) => {
    if (!normalizedQuery) {
      return true;
    }

    return [item?.serviceTitle].some((field) =>
      field?.toLowerCase()?.includes(normalizedQuery),
    );
  });

  const displayUsers =
    filterList?.slice(
      currentPage * usersPerPage,
      (currentPage + 1) * usersPerPage,
    ) || [];

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  const handleOpenAddModal = () => {
    setSelectedService(null);
  };

  const handleOpenEditModal = (service) => {
    setSelectedService(service);
    dispatch(
      fetchPresetById({
        payload: service?.id,
        callback: (res) => {
          if (res?.success && res?.data) {
            setSelectedService(res.data);
          }
        },
      }),
    );
  };

  const handleDelete = () => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchPresets());
      }
    };
    dispatch(deletePreset({ payload: id, callback }));
  };

  const closeServiceModal = () => {
    if (modalRef.current) {
      modalRef.current.classList.remove("show");
      modalRef.current.setAttribute("aria-hidden", "true");
      modalRef.current.style.display = "none";
    }

    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");

    document
      .querySelectorAll(".modal-backdrop")
      .forEach((backdrop) => backdrop.remove());
  };

  const cleanupBootstrapOverlays = () => {
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");

    document
      .querySelectorAll(".modal-backdrop")
      .forEach((backdrop) => backdrop.remove());
  };

  const handleServiceSubmit = async (values, { setSubmitting, resetForm }) => {
    const payload = {
      serviceTitle: values?.serviceTitle?.trim(),
      serviceCost: Number(values?.serviceCost),
      boatLength: values?.boatLength !== "" ? String(values?.boatLength) : null,
      materialCost: values?.materialCost !== "" ? Number(values?.materialCost) : null,
    };

    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchPresets());
        resetForm();
        setSelectedService(null);
        closeServiceModal();
      }
      setSubmitting(false);
    };

    if (selectedService?.id) {
      dispatch(
        updatePreset({
          payload: { ...payload, id: String(selectedService.id) },
          callback,
        }),
      );
      return;
    }

    dispatch(addPreset({ payload, callback }));
  };

  useEffect(() => {
    dispatch(fetchPresets());
  }, []);

  useEffect(() => {
    setCurrentPage(0);
  }, [filterData]);

  useEffect(() => {
    const totalPages = Math.ceil((filterList?.length || 0) / usersPerPage);

    if (totalPages > 0 && currentPage >= totalPages) {
      setCurrentPage(totalPages - 1);
    }

    if (totalPages === 0 && currentPage !== 0) {
      setCurrentPage(0);
    }
  }, [filterList?.length, usersPerPage, currentPage]);

  useEffect(() => {
    return () => {
      cleanupBootstrapOverlays();
    };
  }, []);

  useEffect(() => {
    if (tooltipSeen === true) {
      setRunTour(false);
      return undefined;
    }

    if (!isTourActive || tourStep !== 15) {
      setRunTour(false);
      return undefined;
    }

    const interval = setInterval(() => {
      const el = document.querySelector(".add_service_btn");
      if (el) {
        if (!autoOpenModalAttemptedRef.current) {
          autoOpenModalAttemptedRef.current = true;
          try {
            const persistedStepIndex = Number(
              window?.sessionStorage?.getItem(TOUR_PERSIST_KEY) || 0,
            );
            if (persistedStepIndex >= 1) {
              el?.click?.();
            }
          } catch (_e) {
            // ignore
          }
        }
        setRunTour(true);
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [isTourActive, tooltipSeen, tourStep]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="ct_dashbaord_bg">
      <GuidedTour
        steps={tooltipSeen === true || !isTourActive || tourStep !== 15 ? [] : tourSteps}
        run={runTour && tooltipSeen !== true && isTourActive && tourStep === 15}
        persistKey={TOUR_PERSIST_KEY}
        onSkip={() => {
          setRunTour(false);
          dispatch(resetTour());
        }}
        onComplete={() => {
          setRunTour(false);
          closeServiceModal();
          setShowAllSet(true);
          dispatch(resetTour());
        }}
      />
      {showAllSet ? (
        <div className="tour-allset-overlay">
          <div className="tour-allset-card">
            <div className="tour-allset-icon">
              <i className="fa-solid fa-check"></i>
            </div>
            <h2 className="tour-allset-title">You're All Set</h2>
            <p className="tour-allset-subtitle">
              You're ready to start managing your docks, boats, and services.
            </p>
            <button
              type="button"
              className="tour-allset-btn"
              onClick={() => {
                setShowAllSet(false);
                closeServiceModal();
                cleanupBootstrapOverlays();
                navigate(pageRoutes.dashboard);
              }}
            >
              Get Started
            </button>
          </div>
        </div>
      ) : null}
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="maintenance-details" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />
          <div className="ct_dashbaord_middle">
            <div className="d-flex justify-content-between ct_flex_col_575 gap-3">
              <SubHeader />
            </div>

            <div className="d-flex gap-sm-5 gap-3 w-100 ct_flex_col_575 mt-4">
              <div className="search-box w-100">
                <div className="input-group position-relative">
                  <input
                    value={filterData}
                    onChange={(e) => setFilterData(e.target.value)}
                    className="form-control ct_input ct_input_ps_40 ct_transparent_input"
                    type="text"
                    placeholder="Search by service title"
                  />
                  <i className="fas fa-search ct_show_search"></i>
                </div>
              </div>
              <div class="flex-grow-1 ct_w_100_575">
                <a
                  className="ct_orange_btn d-inline-block ct_w_100_575 px-3  ct_h_50 add_service_btn"
                  data-bs-toggle="modal"
                  data-bs-target="#ct_service_modal"
                  onClick={handleOpenAddModal}
                >
                  <svg
                    className="me-2"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 20.625C5.6925 20.625 1.375 16.3075 1.375 11C1.375 5.6925 5.6925 1.375 11 1.375C16.3075 1.375 20.625 5.6925 20.625 11C20.625 16.3075 16.3075 20.625 11 20.625ZM11 2.75C6.44875 2.75 2.75 6.44875 2.75 11C2.75 15.5512 6.44875 19.25 11 19.25C15.5512 19.25 19.25 15.5512 19.25 11C19.25 6.44875 15.5512 2.75 11 2.75Z"
                      fill="white"
                    />
                    <path
                      d="M11 15.8125C10.615 15.8125 10.3125 15.51 10.3125 15.125V6.875C10.3125 6.49 10.615 6.1875 11 6.1875C11.385 6.1875 11.6875 6.49 11.6875 6.875V15.125C11.6875 15.51 11.385 15.8125 11 15.8125Z"
                      fill="white"
                    />
                    <path
                      d="M15.125 11.6875H6.875C6.49 11.6875 6.1875 11.385 6.1875 11C6.1875 10.615 6.49 10.3125 6.875 10.3125H15.125C15.51 10.3125 15.8125 10.615 15.8125 11C15.8125 11.385 15.51 11.6875 15.125 11.6875Z"
                      fill="white"
                    />
                  </svg>
                  Add Service{" "}
                </a>
              </div>
            </div>

            <div class="ct_white_bg p-4 ct_border_radius_12 ct_mt_30">
              <div class="custom_table_wrapper">
                <div class="table-responsive  ct_custom_table">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>S.no</th>
                        <th>Service Title</th>
                        <th>Total Cost</th>
                        <th>Boat length </th>
                        <th>Material Cost</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    {displayUsers?.length != 0 ? (
                      <tbody>
                        {displayUsers?.map((item, i) => (
                          <tr key={item?.id ?? i}>
                            <td class="ct_text_para">
                              {currentPage * usersPerPage + i + 1}
                            </td>
                            <td class="ct_text_para">
                              {" "}
                              <div className="ct_overlay_text">
                                {item?.serviceTitle ?? "-"}
                              </div>
                            </td>
                            <td class="ct_text_para">
                              {" "}
                              {curSym} {item?.serviceCost ?? "-"}
                            </td>
                            <td class="ct_text_para">{getOptionLabel(
                              lengthOptions,
                              item?.boatLength,
                            ) ?? "-"} </td>
                            <td class="ct_text_para">{curSym} {item?.materialCost ?? "-"}</td>
                            <td>
                              <div class="d-flex gap-2">
                                <a
                                  href="#"
                                  data-bs-toggle="modal"
                                  data-bs-target="#ct_service_modal"
                                  onClick={() => handleOpenEditModal(item)}
                                >
                                  <svg
                                    width="19"
                                    height="19"
                                    viewBox="0 0 19 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M15.1128 11.4329V14.9479C15.1126 15.4453 14.9149 15.9222 14.5633 16.2738C14.2116 16.6255 13.7347 16.8232 13.2373 16.8234H4.05323C3.80603 16.8233 3.56129 16.7743 3.33307 16.6794C3.10486 16.5844 2.89765 16.4452 2.72338 16.2699C2.5491 16.0946 2.41118 15.8866 2.31755 15.6578C2.22392 15.429 2.17641 15.184 2.17777 14.9368V5.763C2.1763 5.5162 2.22382 5.27156 2.31759 5.04326C2.41136 4.81495 2.54951 4.60753 2.72403 4.43301C2.89855 4.25849 3.10597 4.12035 3.33427 4.02658C3.56257 3.93281 3.80721 3.88528 4.05402 3.88675H7.56823"
                                      stroke="#009C35"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M15.112 7.12127L11.8781 3.88652M5.41016 12.5109V10.797C5.41174 10.5144 5.52416 10.2428 5.72287 10.0425L13.269 2.49635C13.3692 2.3951 13.4884 2.31472 13.6198 2.25986C13.7512 2.205 13.8922 2.17676 14.0346 2.17676C14.177 2.17676 14.318 2.205 14.4494 2.25986C14.5808 2.31472 14.7 2.3951 14.8001 2.49635L16.503 4.19923C16.6042 4.29936 16.6846 4.41858 16.7395 4.54998C16.7943 4.68139 16.8226 4.82237 16.8226 4.96477C16.8226 5.10717 16.7943 5.24815 16.7395 5.37956C16.6846 5.51096 16.6042 5.63018 16.503 5.73031L8.95682 13.2765C8.75616 13.4758 8.48516 13.5881 8.20237 13.5892H6.48841C6.34675 13.5894 6.20645 13.5616 6.07553 13.5075C5.94462 13.4534 5.82567 13.374 5.7255 13.2738C5.62534 13.1737 5.54592 13.0547 5.49181 12.9238C5.4377 12.7929 5.40995 12.6526 5.41016 12.5109Z"
                                      stroke="#009C35"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </a>
                                <a
                                  href="#"
                                  data-bs-toggle="modal"
                                  data-bs-target="#delete_modal"
                                  onClick={(e) => {
                                    setId(item?.id);
                                  }}
                                >
                                  <svg
                                    width="19"
                                    height="19"
                                    viewBox="0 0 19 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.80301 4.07171H11.1959C11.1959 3.62179 11.0171 3.19029 10.699 2.87215C10.3809 2.55401 9.94936 2.37528 9.49944 2.37528C9.04952 2.37528 8.61803 2.55401 8.29988 2.87215C7.98174 3.19029 7.80301 3.62179 7.80301 4.07171ZM6.78516 4.07171C6.78516 3.35183 7.07112 2.66144 7.58015 2.15242C8.08918 1.64339 8.77957 1.35742 9.49944 1.35742C10.2193 1.35742 10.9097 1.64339 11.4187 2.15242C11.9278 2.66144 12.2137 3.35183 12.2137 4.07171H16.4548C16.5898 4.07171 16.7192 4.12533 16.8147 4.22077C16.9101 4.31621 16.9637 4.44566 16.9637 4.58064C16.9637 4.71561 16.9101 4.84506 16.8147 4.9405C16.7192 5.03594 16.5898 5.08956 16.4548 5.08956H15.5659L14.74 14.9987C14.68 15.7196 14.3512 16.3916 13.8189 16.8814C13.2866 17.3712 12.5897 17.6431 11.8663 17.6431H7.13258C6.40922 17.6431 5.71229 17.3712 5.18 16.8814C4.6477 16.3916 4.31892 15.7196 4.25883 14.9987L3.43301 5.08956H2.54408C2.40911 5.08956 2.27966 5.03594 2.18422 4.9405C2.08878 4.84506 2.03516 4.71561 2.03516 4.58064C2.03516 4.44566 2.08878 4.31621 2.18422 4.22077C2.27966 4.12533 2.40911 4.07171 2.54408 4.07171H6.78516ZM5.2733 14.9139C5.31211 15.3804 5.52479 15.8152 5.86918 16.1322C6.21357 16.4492 6.66452 16.6252 7.13258 16.6253H11.8663C12.3344 16.6252 12.7853 16.4492 13.1297 16.1322C13.4741 15.8152 13.6868 15.3804 13.7256 14.9139L14.5453 5.08956H4.45426L5.2733 14.9139ZM7.97266 7.46456C8.10763 7.46456 8.23708 7.51818 8.33252 7.61363C8.42796 7.70907 8.48158 7.83852 8.48158 7.97349V13.7413C8.48158 13.8763 8.42796 14.0058 8.33252 14.1012C8.23708 14.1967 8.10763 14.2503 7.97266 14.2503C7.83768 14.2503 7.70823 14.1967 7.61279 14.1012C7.51735 14.0058 7.46373 13.8763 7.46373 13.7413V7.97349C7.46373 7.83852 7.51735 7.70907 7.61279 7.61363C7.70823 7.51818 7.83768 7.46456 7.97266 7.46456ZM11.5352 7.97349C11.5352 7.83852 11.4815 7.70907 11.3861 7.61363C11.2907 7.51818 11.1612 7.46456 11.0262 7.46456C10.8913 7.46456 10.7618 7.51818 10.6664 7.61363C10.5709 7.70907 10.5173 7.83852 10.5173 7.97349V13.7413C10.5173 13.8763 10.5709 14.0058 10.6664 14.1012C10.7618 14.1967 10.8913 14.2503 11.0262 14.2503C11.1612 14.2503 11.2907 14.1967 11.3861 14.1012C11.4815 14.0058 11.5352 13.8763 11.5352 13.7413V7.97349Z"
                                      fill="#CB0B03"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tfoot>
                        <tr>
                          <td
                            className="text-center bg-transparent border-0"
                            colSpan="9"
                          >
                            <div className="text-center">
                              <p className="mb-0 mt-3 text-center">
                                No service found
                              </p>
                            </div>
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
              </div>


              <ServicePresetModal
                isEditMode={Boolean(selectedService?.id)}
                modalRef={modalRef}
                onSubmit={handleServiceSubmit}
                selectedService={selectedService}
              />

              {/*   <!-- delete  maintenance modal --> */}

              <DeleteModal
                handleDelete={handleDelete}
                heading="Delete Service"
                value="Are you sure you want to delete this service?"
              />
              <div className="service_presets_finish_anchor" />
            </div>
            <div className="mt-3">
              {filterList?.length >= 5 && filterList?.length > 0 && (
                <div className="d-flex align-items-center flex-wrap justify-content-between gap-3 mb-3">
                  <PaginationDropdown
                    onChange={(val) => {
                      setUserPerPages(val);
                      setCurrentPage(0);
                    }}
                  />
                  <ReactPagination
                    pageCount={Math.ceil(filterList.length / usersPerPage)}
                    onPageChange={handlePageClick}
                    currentPage={currentPage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageServicePresets;
